/* eslint-disable @typescript-eslint/no-explicit-any */
import { calculateSeatedTime, formatSeatedTime, millisToNextMinute } from 'utils/timeUtils';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  seatedTimeSec: number;
}

export default class ServiceAerialTableSeatedTime extends BaseComponent<Props> {
  _updateInterval: any = null;

  shouldComponentUpdate(nextProps: any, nextState: any): boolean {
    return this.props.seatedTimeSec !== nextProps.seatedTimeSec;
  }

  componentDidMount(): void {
    const { seatedTimeSec } = this.props;
    const millisToNextMin = millisToNextMinute(calculateSeatedTime(seatedTimeSec));
    setTimeout(() => {
      if (!this._updateInterval) {
        this.handleRefresh();
        this._updateInterval = setInterval(this.handleRefresh, 60000);
      }
    }, millisToNextMin);
  }

  componentWillUnmount(): void {
    if (this._updateInterval) {
      clearInterval(this._updateInterval);
      this._updateInterval = null;
    }
  }

  handleRefresh(): void {
    this.forceUpdate();
  }

  render() {
    const { seatedTimeSec } = this.props;

    return (
      <span className="ServiceAerialTable-timeBubble ServiceAerialTable-seatedTime">
        {formatSeatedTime(seatedTimeSec)}
      </span>
    );
  }
}
